import React from 'react'
import log from 'loglevel'
import { CONTROL_STATUS } from '@trustero/trustero-api-web/lib/model/control_pb'
import { VendorRecord } from '@trustero/trustero-api-web/lib/vendormanagement/vendormanagement_pb'
import { showInfoToast } from 'src/Utils/helpers/toast'
import { useCurrentControl } from 'src/context/FormContext'
import { ModalFormId } from 'src/components/ModalForms'
import {
  MODEL_TYPE,
  RESPONSIBILITY,
} from '@trustero/trustero-api-web/lib/common/model_pb'
import { ResponsibilityForm } from 'src/components/Reusable/Forms/ResponsibilityForm'
import { useUpdateControlFields } from 'src/components/async/model/control/useControlMutations'
import { isNotApplicableResponsibility } from 'src/lib/common/types'
import { ERROR_MARKING_CONTROL_NA } from './ControlModals.constants'

export const ControlResponsibilityModal = (): JSX.Element => {
  const updateControlFields = useUpdateControlFields()

  const { currentControl, updatedResponsibility } = useCurrentControl()

  const updateControlResponsibility = async (
    responsibility: RESPONSIBILITY,
    naReason: string,
    selectedVendor: VendorRecord | null,
  ) => {
    if (!currentControl.id) {
      throw new Error('No control id provided')
    }
    try {
      await updateControlFields({
        controlId: currentControl.id,
        responsibility,
        notApplicableReason: naReason,
        status: isNotApplicableResponsibility(responsibility)
          ? CONTROL_STATUS.NOTAPPLICABLE
          : CONTROL_STATUS.NEEDSATTENTION,
        vendorId: selectedVendor?.getId(),
      })
    } catch (error) {
      showInfoToast(ERROR_MARKING_CONTROL_NA)
      log.error(
        `Error marking control with id ${currentControl.id} not applicable`,
        error,
      )
    }
  }

  return (
    <ResponsibilityForm
      id={currentControl.id}
      modelType={MODEL_TYPE.CONTROL}
      modalId={ModalFormId.MARK_CONTROL_NA}
      currentResponsibility={currentControl.responsibility}
      updatedResponsibility={updatedResponsibility}
      onUpdate={updateControlResponsibility}
    />
  )
}
